import api from '../../utils/api';
import { GeoLocationLevelType } from '../../types/mdm';

const authEndpoint: string = `${process.env.REACT_APP_ENDPOINT}/mdm/location-level`;

const fetchAll = () => {
  return api.get(`${authEndpoint}`);
};
const fetchOne = (id: number) => {
  return api.get(`${authEndpoint}/${id}`);
};

const create = (data: GeoLocationLevelType) => {
  return api.post(`${authEndpoint}`, data);
};

const update = (id: number, data: GeoLocationLevelType) => {
  return api.put(`${authEndpoint}/${id}`, data);
};
const destroy = (id: number) => {
  return api.delete(`${authEndpoint}/${id}`);
};

export default { fetchAll, fetchOne, create, update, destroy };
